export default __webpack_public_path__ + "static/media/icaew_m3.f541eb92.png";